
import state from './salesForecastState.js'
import * as mutations from './salesForecastMutations.js'
import * as actions from './salesForecastActions.js'
import * as getters from './salesForecastGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}